import { GenericMapping, GenericMappingType } from '../../search/types'

export const INTERCOM_GENERIC_MAPPINGS: GenericMapping[] = [
  {
    key: 'state',
    type: GenericMappingType.KEYWORD,
    name: 'State',
    description: 'The state of the conversation',
    enum: ['open', 'closed', 'snoozed'],
  },
  {
    key: 'priority',
    type: GenericMappingType.KEYWORD,
    name: 'Priority',
    description: 'The priority of the conversation',
    enum: ['priority', 'not_priority'],
  },
  {
    key: 'assignee',
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'The admin assigned to the conversation',
  },
  {
    key: 'team',
    type: GenericMappingType.KEYWORD,
    name: 'Team',
    description: 'The team assigned to the conversation',
  },
  {
    key: 'tags',
    type: GenericMappingType.KEYWORD,
    name: 'Tags',
    description: 'The tags associated with the conversation',
  },
  {
    key: 'creator',
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'The user who created the conversation',
  },
  {
    key: 'rating',
    type: GenericMappingType.NUMBER,
    name: 'Rating',
    description: 'The rating given to the conversation',
  },
] as const
